/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const userNestedSerializerForFormVersionsUsernameMax = 150;

export const userNestedSerializerForFormVersionsUsernameRegExp = new RegExp(
    '[\\w.@+-]+',
);
export const userNestedSerializerForFormVersionsFirstNameMax = 150;

export const userNestedSerializerForFormVersionsLastNameMax = 150;

export const UserNestedSerializerForFormVersions = zod.strictObject({
    id: zod.number(),
    username: zod
        .string()
        .max(userNestedSerializerForFormVersionsUsernameMax)
        .regex(userNestedSerializerForFormVersionsUsernameRegExp)
        .describe(
            'Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.',
        ),
    first_name: zod
        .string()
        .max(userNestedSerializerForFormVersionsFirstNameMax)
        .optional(),
    last_name: zod
        .string()
        .max(userNestedSerializerForFormVersionsLastNameMax)
        .optional(),
});

export type UserNestedSerializerForFormVersions = zod.input<
    typeof UserNestedSerializerForFormVersions
>;
export type UserNestedSerializerForFormVersionsOutput = zod.output<
    typeof UserNestedSerializerForFormVersions
>;
